// slider images
import img1 from './images/carousel/1.jpg';
import img2 from './images/carousel/2.jpg';
import img3 from './images/carousel/3.jpg';
import img4 from './images/carousel/4.jpg';
import img5 from './images/carousel/5.jpg';
import img6 from './images/carousel/6.jpg';
import img7 from './images/carousel/7.jpg';
import img8 from './images/carousel/8.jpg';

import imgThumb1 from './images/carousel/1-thumb.jpg';
import imgThumb2 from './images/carousel/2-thumb.jpg';
import imgThumb3 from './images/carousel/3-thumb.jpg';
import imgThumb4 from './images/carousel/4-thumb.jpg';
import imgThumb5 from './images/carousel/5-thumb.jpg';
import imgThumb6 from './images/carousel/6-thumb.jpg';
import imgThumb7 from './images/carousel/7-thumb.jpg';
import imgThumb8 from './images/carousel/8-thumb.jpg';

// rooms images

import deluxe from './images/room-deluxeworld.jpg';
import deluxe2 from './images/room-deluxeworld-2.jpg';
import executive from './images/room-executive.jpg';
import executive2 from './images/room-executive-2.jpg';
import executive3 from './images/room-executive-3.jpg';
import executive4 from './images/room-executive-4.jpg';
import worldClub from './images/room-worldclub.jpg';
import worldClub2 from './images/room-worldclub-2.jpg';
import worldClub3 from './images/room-worldclub-3.jpg';

import mapMarkerOfficial from './images/official-venue.png';
import mapMarkerDefault from './images/pin.png';
import mapMobileMarker1 from './images/map-mobile-marker-1.svg';
import mapMobileMarker2 from './images/map-mobile-marker-2.svg';
import mapMobileMarker3 from './images/map-mobile-marker-3.svg';
import mapMobileMarker4 from './images/map-mobile-marker-4.svg';
import mapMobileMarker5 from './images/map-mobile-marker-5.svg';
import mapMobileMarker6 from './images/map-mobile-marker-6.svg';

import hotelMarker1 from './images/marker-hotel-1.svg';
import hotelMarker2 from './images/marker-hotel-2.svg';
import hotelMarker3 from './images/marker-hotel-3.svg';
import hotelMarker4 from './images/marker-hotel-4.svg';
import hotelMarker5 from './images/marker-hotel-5.svg';
import hotelMarker6 from './images/marker-hotel-6.svg';

import ac from './images/amenities/icon-aircon.svg';
import bar from './images/amenities/icon-bar.svg';
import breakfast from './images/amenities/icon-breakfast.svg';
import coffee from './images/amenities/icon-coffee.svg';
import pwd from './images/amenities/icon-pwd.svg';
import gym from './images/amenities/icon-gym.svg';
import resto from './images/amenities/icon-resto.png';
import shuttle from './images/amenities/icon-shuttle.png';
import smoking from './images/amenities/icon-smoking.svg';
import spa from './images/amenities/icon-spa.svg';
import pool from './images/amenities/icon-pool.svg';

import novotel1 from './images/partner-hotels/novotel/novotel-1.jpg';
import novotel2 from './images/partner-hotels/novotel/novotel-2.jpg';
import novotel3 from './images/partner-hotels/novotel/novotel-3.jpg';
import novotel4 from './images/partner-hotels/novotel/novotel-4.jpg';

import hyatt1 from './images/partner-hotels/grand-hyatt/grandhyatt-1.jpg';
import hyatt2 from './images/partner-hotels/grand-hyatt/grandhyatt-2.jpg';
import hyatt3 from './images/partner-hotels/grand-hyatt/grandhyatt-3.jpg';
import hyatt4 from './images/partner-hotels/grand-hyatt/grandhyatt-4.jpg';

import kempinski1 from './images/partner-hotels/kempinski/kempinski-1.jpg';
import kempinski2 from './images/partner-hotels/kempinski/kempinski-2.jpg';
import kempinski3 from './images/partner-hotels/kempinski/kempinski-3.jpg';
import kempinski4 from './images/partner-hotels/kempinski/kempinski-4.jpg';
import kempinski5 from './images/partner-hotels/kempinski/kempinski-5.jpg';

import holibangkok from './images/partner-hotels/holiday-inn-bangkok/holidayinn.jpg';
import holibangkok1 from './images/partner-hotels/holiday-inn-bangkok/holiday-1.jpg';
import holibangkok2 from './images/partner-hotels/holiday-inn-bangkok/holiday-2.jpg';
import holibangkok3 from './images/partner-hotels/holiday-inn-bangkok/holiday-3.jpg';
import holibangkok4 from './images/partner-hotels/holiday-inn-bangkok/holiday-4.jpg';

import holisiam1 from './images/partner-hotels/holiday-express-siam/holiday-siam-1.jpg';
import holisiam2 from './images/partner-hotels/holiday-express-siam/holiday-siam-2.jpg';
import holisiam3 from './images/partner-hotels/holiday-express-siam/holiday-siam-3.jpg';
import holisiam4 from './images/partner-hotels/holiday-express-siam/holiday-siam-4.jpg';

import conrad1 from './images/partner-hotels/conrad/conrad-1.jpg';
import conrad2 from './images/partner-hotels/conrad/conrad-2.jpg';
import conrad3 from './images/partner-hotels/conrad/conrad-3.jpg';
import conrad4 from './images/partner-hotels/conrad/conrad-4.jpg';

export const hotelsMeta = [
  {
    name: 'Centara Grand At Central World',
    desc: 'Centara Grand is the official home of Sellers World Conference speakers, exhibitors, and attendees. The conference venue is an elevator ride away and is an ideal place to host meetings, connect over a meal, or just run into friends at one of the several top-class rooftop bars.',
    position: {
      lat: 13.747717,
      lng: 100.5365583,
    },
    marker: mapMarkerOfficial,
    markerMobile: mapMarkerOfficial,
    distance: 0,
    rating: 10,
    stars: 5,
    perfectFor: ['Luxury', 'Location', 'Room Variety'],
    amenities: ['pool', 'shuttle', 'gym', 'spa', 'pwd', 'resto', 'bar', 'breakfast', 'ac', 'coffee'],
    featured: true,
    images: [img1],
    roomImages: [deluxe, executive, worldClub],
    deeplink: 'https://reservations.verticalbooking.com/premium/index.html?dc=2294&id_albergo=19388&lingua_int=eng&id_stile=16001&codice_roomlist=2811AFFIL001%7C178058',
  },
  {
    name: 'Novotel Bangkok Siam Square',
    desc: 'A popular choice for SWC2019 attendees. Novotel offers plenty of facilities including a large outdoor pool, sauna room, day spa and fitness centre at affordable prices.',
    position: {
      lat: 13.7443075,
      lng: 100.5325388,
    },
    marker: mapMarkerDefault,
    markerMobile: mapMobileMarker1,
    hotelMarker: hotelMarker1,
    distance: 10,
    rating: 8.2,
    stars: 4,
    perfectFor: ['Location', 'Mid-Range'],
    amenities: ['pool', 'shuttle', 'gym', 'spa', 'pwd', 'bar', 'breakfast', 'ac'],
    deeplink: 'https://www.securebookinghotels.com/city2.asp?id=109&idc=485&idh=2147&#afinal',
    images: [novotel1, novotel2, novotel3, novotel4],
    roomImages: [novotel1, novotel3, novotel4],
  },
  {
    name: 'Grand Hyatt Erawan Bangkok',
    desc: '5-star hotel featuring stunning views of the Bangkok cityscape with luxurious, spacious rooms. Grand Hyatt Erawan Bangkok offers 9 restaurants and bar, award-winning Spa & Club, swimming pool, fitness centre and more.',
    position: {
      lat: 13.743528,
      lng: 100.5383002,
    },
    marker: mapMarkerDefault,
    markerMobile: mapMobileMarker2,
    hotelMarker: hotelMarker2,
    distance: 8,
    rating: 8.9,
    stars: 5,
    perfectFor: ['Luxury', 'Location', 'Room Variety'],
    amenities: ['pool', 'shuttle', 'gym', 'spa', 'pwd', 'resto', 'bar', 'breakfast', 'ac', 'coffee'],
    deeplink: 'https://www.securebookinghotels.com/city2.asp?id=109&idc=485&idh=2146&#afinal',
    images: [hyatt1, hyatt2, hyatt3, hyatt4],
    roomImages: [hyatt1, hyatt1, hyatt2, hyatt3],
  },
  {
    name: 'Siam Kempinski Hotel',
    desc: 'Luxurious 5-star Siam Kempinski Hotel Bangkok is minutes from the SWC2019 venue. The hotel features multiple pools, fine dining, a world-class spa, plus a range of higher end room options.',
    position: {
      lat: 13.7484307,
      lng: 100.5325674,
    },
    marker: mapMarkerDefault,
    markerMobile: mapMobileMarker3,
    hotelMarker: hotelMarker3,
    distance: 6,
    rating: 9.1,
    stars: 5,
    perfectFor: ['Luxury', 'Location', 'Room Variety'],
    amenities: ['pool', 'shuttle', 'gym', 'spa', 'pwd', 'resto', 'bar', 'breakfast', 'ac', 'coffee'],
    deeplink: 'https://www.securebookinghotels.com/city2.asp?id=109&idc=485&idh=2149&#afinal',
    images: [kempinski1, kempinski2, kempinski3, kempinski4, kempinski5],
    roomImages: [kempinski1, kempinski2, kempinski3],
  },
  {
    name: 'Holiday Inn Bangkok',
    desc: 'Located across Bangkok Central World Plaza and Gaysorn Plaza, Holiday Inn Bangkok offers luxurious rooms at affordable prices. Services include a fitness centre, a pool and 3 dining options.',
    position: {
      lat: 13.7459087,
      lng: 100.5394851,
    },
    marker: mapMarkerDefault,
    markerMobile: mapMobileMarker4,
    hotelMarker: hotelMarker4,
    distance: 9,
    rating: 8.7,
    stars: 4,
    perfectFor: ['Budget', 'Location'],
    amenities: ['pool', 'shuttle', 'gym', 'spa', 'pwd', 'resto', 'bar', 'breakfast', 'ac'],
    deeplink: 'https://www.securebookinghotels.com/city2.asp?id=109&idc=485&idh=2145&#afinal',
    images: [holibangkok1, holibangkok2, holibangkok3, holibangkok4, holibangkok],
    roomImages: [holibangkok1, holibangkok2],
  },
  {
    name: 'Holiday Inn Express Bangkok Siam',
    desc: 'An elegant, modern hotel conveniently located to a BTS Skytrain Station, short cab ride to the SWC2019 venue and shopping centres. The Holiday Inn Express Bangkok Siam features a rooftop 24-hour fitness centre and free WiFi.',
    position: {
      lat: 13.7472873,
      lng: 100.5255824,
    },
    marker: mapMarkerDefault,
    markerMobile: mapMobileMarker5,
    hotelMarker: hotelMarker5,
    distance: 19,
    rating: 8.2,
    stars: 2,
    perfectFor: ['Budget'],
    amenities: ['gym', 'spa', 'pwd', 'resto', 'bar', 'breakfast', 'ac'],
    deeplink: 'https://www.securebookinghotels.com/city2.asp?id=109&idc=485&idh=2148&#afinal',
    images: [holisiam1, holisiam2, holisiam3, holisiam4],
    roomImages: [holisiam1],
  },
  {
    name: 'Conrad Bangkok Residences',
    desc: 'Situated within Conrad Hotel in Bangkok’s All Seasons Place, these stylish residences combine the exclusive services of the hotel with the privacy and independence of your own luxury apartment. Rooms available on request and are subject to availability.',
    position: {
      lat: 13.7384271,
      lng: 100.5458902,
    },
    marker: mapMarkerDefault,
    markerMobile: mapMobileMarker6,
    hotelMarker: hotelMarker6,
    distance: 100,
    rating: 8.2,
    stars: 2,
    perfectFor: ['Budget', 'The Squad!'],
    amenities: ['pool', 'shuttle', 'gym', 'pwd', 'bar', 'breakfast', 'ac'],
    deeplink: 'https://www.securebookinghotels.com/city2.asp?id=109&idc=485&idh=2151&#afinal',
    images: [conrad1, conrad2, conrad3, conrad4],
    roomImages: [],
    priceOnEnquiry: true,
  },
];

export const featuredRooms = [
  {
    name: 'Deluxe World',
    sliders: [deluxe, deluxe2],
    desc: 'Enjoy great city views while relaxing in your living area with a soothing décor and a host of amenities.',
    listOne: 'Includes breakfast and high-speed wifi',
    listTwo: 'Available in single, double, and triple occupancy',
  },
  {
    name: 'World Club',
    sliders: [worldClub, worldClub2, worldClub3],
    desc: 'Get the city views and all Club benefits with the World Club room that exudes comfort',
    listOne: 'Includes breakfast and high-speed wifi',
    listTwo: 'Available in single, double, and triple occupancy',
  },
  {
    name: 'Executive Suite',
    sliders: [executive, executive2, executive3, executive4],
    desc: 'The luxurious Executive Suite offers living and dining areas with a spacious bedroom, plus all Club benefits.',
    listOne: 'Includes breakfast and high-speed wifi',
    listTwo: 'Available in single, double, and triple occupancy',
  },
];

export const images = [
  {
    img: img1,
    thumb: imgThumb1,
  },
  {
    img: img2,
    thumb: imgThumb2,
  },
  {
    img: img3,
    thumb: imgThumb3,
  },
  {
    img: img4,
    thumb: imgThumb4,
  },
  {
    img: img5,
    thumb: imgThumb5,
  },
  {
    img: img6,
    thumb: imgThumb6,
  },
  {
    img: img7,
    thumb: imgThumb7,
  },
  {
    img: img8,
    thumb: imgThumb8,
  },
];

export const hotelAmenities = {
  pool: {
    name: 'Swimming pool',
    icon: pool,
  },
  spa: {
    name: 'Spa & wellness centre',
    icon: spa,
  },
  shuttle: {
    name: 'Airport shuttle',
    icon: shuttle,
  },
  breakfast: {
    name: 'Breakfast',
    icon: breakfast,
  },
  bar: {
    name: 'Bar',
    icon: bar,
  },
  smoking: {
    name: 'Non-smoking rooms',
    icon: smoking,
  },
  gym: {
    name: 'Fitness centre',
    icon: gym,
  },
  pwd: {
    name: 'Facilities for disabled guests',
    icon: pwd,
  },
  resto: {
    name: 'Restaurants',
    icon: resto,
  },
  coffee: {
    name: 'Tea/coffee maker in all rooms',
    icon: coffee,
  },
  ac: {
    name: 'Air Conditioning',
    icon: ac,
  },
};

/* eslint-disable */
const mapStyles = [
  {
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#f5f5f5"
      }
    ]
  },
  {
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#616161"
      }
    ]
  },
  {
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#f5f5f5"
      }
    ]
  },
  {
    "featureType": "administrative.land_parcel",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#bdbdbd"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#eeeeee"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e5e5e5"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#ffffff"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#dadada"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#616161"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  },
  {
    "featureType": "transit.line",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e5e5e5"
      }
    ]
  },
  {
    "featureType": "transit.station",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#eeeeee"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#c9c9c9"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  }
];
/* eslint-disable */
export const MapStyle = {
  defaultZoom: 15,
  defaultCenter: { lat: 13.747717, lng: 100.5365583, },
  defaultOptions: {
    styles: mapStyles,
    scrollwheel: false,
  },
};



// WEBPACK FOOTER //
// ./src/containers/Hotel/constants.js